
<div class="rich-text-content" appInnerHtml [innerHTML]="html">

</div>
